<template>
  <div class="containerP">
   <topoDecla />
   <p class="txtDecla">{{$store.state.estado}} | <span style="font-weight:300;">Declarações Estaduais</span></p>
   <Conteudo   v-if="$store.state.spiner"/> 
   <Spiner v-else />
  </div>
</template>

<script>
import Conteudo from '../components/Conteudo.vue'
import Spiner from '../components/Spiner.vue'
import cofing from '../services/config'
export default {
components:{
  Conteudo,
  Spiner
},
async created(){
    let obj = JSON.parse(localStorage.getItem('declaracoes'))
    this.$store.state.estado = obj.estado
    if(obj.uf !='fed'){
       this.$store.state.dados  = await cofing.buscar(obj)
        this.$store.state.dados.forEach(element => {
          if(element.data.length != 0 && element.data != ""){
              let data = element.data.split('-')
               data = data[2] +'/'+data[1]+"/"+data[0]
              element.data = data
          }
            });
           
       
       this.$store.state.spiner= true
    }
    console.log( this.$store.state.dados )
}
}
</script>

<style>

</style>